// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3im0_","rootSmall":"AddTileButton_rootSmall__1rxcF"};